export default __webpack_public_path__ + "static/media/SFPRODISPLAYMEDIUM.b85d841d.OTF";